import React, { forwardRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Slide from "@mui/material/Slide";
import { Alert, Box } from "@mui/material";

import { DataTypes } from "../../../../constants";
import tmsActions from "../../../../actions/tmsActions";
import {
    getLaunchURL,
    getLaunchURLError,
    isFetching,
} from "../../../../reducers";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});

export default function ModuleMediaLauncher({ media, moduleId, onSave }) {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    const fetching = useSelector((state) =>
        isFetching(state, DataTypes.TMS_LAUNCH_URL, moduleId)
    );
    const launchURL = useSelector((state) => getLaunchURL(state, moduleId));
    const error = useSelector((state) => getLaunchURLError(state, moduleId));

    if (!fetching && launchURL === null) {
        dispatch(tmsActions.getLaunchURL(moduleId, "C-TMS"));
    }
    if (!launchURL) {
        return !error ? null : (
            <Alert
                severity="error"
                icon={<ErrorOutlineIcon fontSize="medium" />}
            >
                <strong>{error.message || "An error has occurred"}</strong>
            </Alert>
        );
    }

    const title = media.name || "Untitled";

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        onSave();
        setOpen(false);
    };

    return (
        <div>
            <Button
                id={`launch_mod_${moduleId}`}
                variant="contained"
                onClick={handleClickOpen}
                aria-labelledby={`launch_mod_${moduleId} mod_${moduleId}_title`}
                className="btn-medium"
                disableElevation={true}
            >
                Launch
            </Button>

            <Dialog
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
                fullScreen
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: "fixed" }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleSave}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography
                            sx={{ ml: 2, flex: 1 }}
                            variant="h6"
                            component="h2"
                        >
                            {title}
                        </Typography>
                        <Button
                            autoFocus
                            variant=""
                            color="primary"
                            onClick={handleSave}
                        >
                            save
                        </Button>
                    </Toolbar>
                </AppBar>

                <Box className="media-placeholder media-placeholder-eLearning">
                    <iframe
                        title={title}
                        src={launchURL}
                        width="100%"
                        height="100%"
                    />
                </Box>
            </Dialog>
        </div>
    );
}
